<template>
  <div class="module dt-top-simple">
    <div class="dt-top-simple-sec">
      <header class="dt-header-simple">
        <a
          v-show="backStatus"
          class="back"
          uigs="head_back"
          href="javascript:void(0);"
          @click="backPrev"
        />
        <h1>{{ headTitle }}</h1>
        <a
          :href="'/?source=node&spver=' + spver"
          class="home"
          uigs="head_home"
        />
        <a
          :href="'/hotsugg?spver=' + spver"
          class="search"
          uigs="head_search"
        />
      </header>
      <div class="dt-info-img-simple">
        <Image-1 :src="item.v_picurl" />
      </div>
      <figure class="dt-info-box-simple">
        <figcaption v-if="item.name">
          {{ item.name }}
        </figcaption>
        <p
          v-if="tag && tag.length > 0"
          class="dt-info-tag-simple"
        >
          <template v-for="(v, index) in tag">
            <a
              :key="index"
              href="javascript:void(0);"
            >{{ v }}</a>
            <em
              v-if="index !== tag.length - 1"
              :key="index"
            >/</em>
          </template>
        </p>
        <p
          v-if="item.starring && typeof item.starring !== undefined"
          class="dt-info-tag-simple"
        >
          <span>主演：</span>
          <template v-for="(str, index) in item.starring.split(';')">
            <em
              v-if="index !== 0"
              :key="index"
            >&nbsp;</em>
            <a
              :key="index"
              href="javascript:void(0);"
              uigs="basic_out"
            >{{ str }}</a>
          </template>
        </p>
      </figure>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { getSpver } from '../../common/js/util';
import Image from './Image.vue';

export default {
  components: {
    'Image-1': Image,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headTitle: this.title,
      backStatus: false,
    };
  },
  computed: {
    ...mapState('detail', ['itemData']),
    item() {
      return this.itemData;
    },
    tag() {
      const tag = [];
      const item = this.itemData;
      if (item) {
        if (item.year) {
          tag.push(item.year);
        }
        if (item.zone) {
          let zone = item.zone.split(';');
          if (zone.length > 0) {
            [zone] = zone;
          }
          tag.push(zone);
        }
      }
      return tag;
    },
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || '';
    },
  },
  mounted() {
    // 返回按钮处理逻辑
    const uigsUa = navigator.userAgent.toLowerCase();
    const isSogouAPP = uigsUa.indexOf('sogousearch') >= 0;
    const len = isSogouAPP ? 1 : 0;
    const { search } = location;

    if (search && search.indexOf('_bs=1') > -1) {
      this.backStatus = false;
    } else if (history.length > len && document.referrer) {
      this.backStatus = true;
    } else if (isSogouAPP) {
      let rurl = location.href;
      if (search !== '' && typeof search !== 'undefined') {
        rurl += '&_bs=1';
      } else {
        rurl += '?_bs=1';
      }
      history.replaceState(null, null, rurl);
    }
  },
  methods: {
    searchResultUrl(string) {
      return `https://m.sogou.com/web/searchList.jsp?keyword=${string}&ie=utf8&pid=sogou-waps-4c26774d852f6244`;
    },
    backPrev() {
      history.go(-1);
      return false;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.dt-top-simple-sec {
  border-bottom: 1px solid #f5f5f5;
}

.dt-top-simple {
  padding: 0 14px;
  position: relative;
  margin-bottom: 20px;
}

.dt-header-simple {
  height: 57px;
  line-height: 57px;
  text-align: center;
  color: #555;
  font-size: 15px;
  position: relative;

  .back {
    @include sprite-item('detail/back_b');
    @extend %-vertical-center;
    left: 0;
  }
  .home {
    @include sprite-item('detail/home');
    @extend %-vertical-center;
    right: 51px;
    background-position: -82px -97px;
  }
  .search {
    @include sprite-item('detail/search');
    @extend %-vertical-center;
    right: 6px;
    background-position: -33px -45px;
  }
}

.dt-info-box-simple {
  color: #222;
  //padding-bottom: 20px;
  //border-bottom: 1px solid #f5f5f5;
  //height: 115px;
  height: 101px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -moz-box;
  display: -moz-flex;

  flex-direction: column;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-flex-direction: column;
  -ms-flex-direction: column;

  justify-content: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -moz-justify-content: center;
  -ms-flex-pack: center;

  figcaption {
    @include line-clip(2);
    font-size: 17px;
    line-height: 23px;
    margin-bottom: 9px;
    font-weight: bold;
    //margin-top: -4px;
  }
}

.dt-info-img-simple {
  width: 60px;
  height: 85px;
  float: left;
  margin-right: 12px;
  position: relative;
  border-radius: 3px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.dt-info-tag-simple {
  @include line-clip(1);
  margin-bottom: 7px;
  color: #555;
  font-size: 13px;
  padding-top: 1px;
  padding-bottom: 1px;

  a {
    color: #555;
    font-size: 13px;
    margin: 0 3px;
  }

  a:first-of-type {
    margin-left: 0;
  }
}
</style>
